import { render, staticRenderFns } from "./curso-detalles.vue?vue&type=template&id=60b1e6a8&scoped=true&"
import script from "./curso-detalles.vue?vue&type=script&lang=ts&"
export * from "./curso-detalles.vue?vue&type=script&lang=ts&"
import style0 from "./curso-detalles.vue?vue&type=style&index=0&id=60b1e6a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1e6a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
